import { Pipe, PipeTransform } from '@angular/core';
import { Marketplace } from 'src/models/marketplace/marketplace.model';

@Pipe({
    name: 'marketplaceName',
    standalone: false
})
export class MarketplaceNamePipe implements PipeTransform {

	transform(marketplaceUuid: string, marketplaceList: Marketplace[]): string {
		if (!marketplaceUuid || !marketplaceList) {
			throw Error('No uuid or marketplace-list given');
		}

		const marketplace = marketplaceList.find((mp: Marketplace) => {
			return mp.uuid === marketplaceUuid;
		});

		return marketplace?.name || '';
	}

}
